import { combineReducers } from "redux"
import ui from "./uiReducer"
import products from './productsReducer'
import projects from './projectsReducer'
import gallery from './galleryReducer'
import blogs from './blogsReducer'
import events from './eventsReducer'
import teamMembers from './teamMembersReducer'
import states from "./statesReducer"

const rootReducer = combineReducers({
  ui,
  products,
  projects,
  gallery,
  blogs,
  events,
  teamMembers,
  states
})

export default rootReducer